import moment from 'moment'
import { opt } from 'src/types'

import { is_valorized } from './commons.utils'

export const join_str = (...classes: opt<string>[]): string => {
  return classes?.filter((class_) => !!class_)?.join(' ')
}

export const fill_placeholders = (text = '', ...placeholders: opt<string>[]): string => {
  let res = text
  placeholders.forEach((placeholder) => {
    res = res.replace('***', placeholder || '')
  })
  return res
}

export const fill_strong = (text: string, strong_class?: string): JSX.Element => {
  const text_pieces = text.split('<strong>')
  return (
    <span>
      {text_pieces.map((str, idx) =>
        idx % 2 === 0 ? (
          str
        ) : (
          <strong key={idx} className={strong_class}>
            {str}
          </strong>
        )
      )}
    </span>
  )
}

export const to_date = (date?: string, format = 'DD/MM/YYYY'): Date => {
  return new Date(moment(date, format).format('MM/DD/YYYY'))
}

export const format_size = (size = 0): string => {
  const pos = Math.floor(Math.log(size) / Math.log(1024))
  return `${(size / Math.pow(1024, pos)).toFixed(2)} ${['B', 'KB', 'MB', 'GB', 'TB'][pos]}`
}

export const format_number = (digit?: string | number, fixed = 0): opt<string> => {
  if (is_valorized(digit)) {
    const digit_str = String(digit)?.split(' ')[0]
    const digit_num = Number(digit_str?.replace(',', '.'))
    return digit_num
      ?.toFixed(fixed)
      ?.replace('.', ',')
      ?.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }
  return undefined
}

export const unformat_number = (digit?: string): opt<string> => {
  return digit?.replaceAll('.', '').replaceAll(',', '')
}

export const format_euro = (amount?: number): opt<string> => {
  return amount ? `${amount?.toFixed(2)?.replace('.', ',')}€` : undefined
}
